<template>
  <div class="column-md mx-auto py-10">
    <h2 class="heading-3 lg:heading-2 text-2xl font-bold leading-none">CHAMPIONS AND SKINS</h2>

    <div class="flex flex-wrap mt-6">
      <div class="highend-search-input mt-2 lg:mt-0">
        <i class="fas fa-search"></i>
        <input type="text" placeholder="Search this account" v-model="searchString">
      </div>
      <a
        :class="[
                'w-full lg:flex-1 lg:ml-2 simple-btn btn-white mt-2 lg:mt-0',
                mode !== 'rare' && 'btn-ghost'
                ]"
        @click="toggleMode('rare')"
      >RARE SKINS</a>
      <a
        :class="[
                'w-full lg:flex-1 lg:ml-2 simple-btn btn-white mt-2 lg:mt-0',
                mode !== 'skin' && 'btn-ghost'
              ]"
        @click="toggleMode('skin')"
      >ALL SKINS</a>
      <a
        :class="[
                'w-full lg:flex-1 lg:ml-2 simple-btn btn-white mt-2 lg:mt-0',
                mode !== 'champion' && 'btn-ghost'
              ]"
        @click="toggleMode('champion')"
      >CHAMPIONS</a>
    </div>

    <div class="flex-1 flex flex-wrap mt-6 -ml-4">
      <div v-if="matchingItems.length === 0" class="flex-1 flex justify-center items-center">
        <div class="mr-4">
          <img src="/images/misc/teemo_crying.gif" alt="unrankedsmurfs teemo crying">
        </div>
        <div class="flex flex-col">
          <span class="heading-4 heading-gold">NOTHING FOUND</span>
          <span>Please adjust your filter and try again.</span>
        </div>
      </div>
      <div
        class="highend-product-skin-card-container"
        v-for="(item, index) in matchingItems"
        :key="index"
      >
        <a
          :href="item.url"
          target="__blank"
          class="highend-product-skin-card relative"
          :style="{ backgroundImage: `url(${item.image_url})` }"
        >
          <i v-if="item.url" class="fas fa-caret-right clickable-card-icon"></i>
          <div class="text-h4 lg:text-base text-shadow">{{item.name}}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mode: undefined,
      searchString: '',
      items: window['skins-and-champions'],
    };
  },

  methods: {
    toggleMode(newMode) {
      if (this.mode === newMode) {
        this.mode = undefined;
      } else {
        this.mode = newMode;
      }
    },
  },

  computed: {
    matchingItems() {
      return this.items.filter(({ name, type, rare }) => {
        const nameMatch =
          name.toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1;
        const modeMatch =
          !this.mode || this.mode === 'rare' || type === this.mode;
        const rarityMatch = !this.mode || this.mode !== 'rare' || rare;

        return nameMatch && modeMatch && rarityMatch;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.clickable-card-icon {
  @apply absolute bottom-0 right-0;
  @apply mr-1;
  transform: rotate(45deg);
  font-size: 18px;
}
</style>
